import { getNextAvailableRoute } from '@shared/helpers/Route'

import productStructureStore from '@shared/store/productStructure'
import useStatus from '@shared/hooks/useStatus'
import useI18n from '@shared/hooks/useI18n'

import { ROUTE_INDEX, ROUTE_NAME } from '@shared/config/constants'

// HOOKS
const { selectedLanguage } = useI18n()
const { routeStates } = useStatus()

export default [
  {
    beforeEnter: function (to, _from, next) {
      const { hasProducts, isBasketValidForAllProducts, isOnboardingSecured } = routeStates.value

      // basket is invalid => route to persons
      if (!isBasketValidForAllProducts || !hasProducts) {
        next({
          name: ROUTE_NAME.PERSONS,
          params: {
            lang: to.params.lang,
          },
        })

        // basket valid => do the rest
      } else {
        let nextRoute = getNextAvailableRoute(
          {
            name: ROUTE_NAME.APPLICATION,
            meta: {
              index: ROUTE_INDEX.APPLICATION,
            },
            params: {
              lang: to.params.lang,
            },
            path: 'application',
          },
          {},
          true
        )?.path

        if (!nextRoute)
          nextRoute = {
            name: ROUTE_NAME.PERSONS,
            params: {
              lang: to.params.lang,
            },
          }

        nextRoute = Object.assign({}, { params: {} }, nextRoute, { replace: true })
        nextRoute.params.lang = to.params.lang ?? selectedLanguage.value.toLowerCase()

        // onboarding not yet done -> go back!
        if (!isOnboardingSecured) {
          next({
            name: ROUTE_NAME.ONBOARDING,
            params: {
              lang: to.params.lang,
            },
            replace: true,
          })

          // to application -> redirect to first real app-screen
        } else if (to.name === ROUTE_NAME.APPLICATION) {
          next(nextRoute)
        } else {
          next()
        }
      }
    },
    component: () => import('@shared/modules/Dvp/screens/Application/Application'),
    path: 'application/',
    name: ROUTE_NAME.APPLICATION,
    children: [
      {
        beforeEnter: function (_to, _from, next) {
          productStructureStore.ready().then(() => next())
        },
        component: () => import('@shared/modules/Dvp/screens/Application/ScreenExistingCustomerData'),
        meta: {
          index: ROUTE_INDEX.APPLICATION_EXISTING_CUSTOMER_DATA,
          basket: {
            readonly: true,
          },
          hideDefaultOverviewLink: true,
        },
        name: ROUTE_NAME.APPLICATION_EXISTING_CUSTOMER_DATA,
        path: 'existing-customer-data',
      },
      {
        component: () => import('@shared/modules/Dvp/screens/Application/ScreenPersonalData'),
        meta: {
          index: ROUTE_INDEX.APPLICATION_PERSONAL_DATA,
          basket: {
            readonly: true,
          },
          hideDefaultOverviewLink: true,
        },
        name: ROUTE_NAME.APPLICATION_PERSONAL_DATA,
        path: 'personal-data/:personId?',
        props: route => ({
          personId: route.params.personId,
        }),
      },
      {
        component: () => import('@shared/modules/Dvp/screens/Application/ScreenAdminData'),
        meta: {
          index: ROUTE_INDEX.APPLICATION_ADMIN_DATA,
          basket: {
            readonly: true,
          },
          hideDefaultOverviewLink: true,
        },
        name: ROUTE_NAME.APPLICATION_ADMIN_DATA,
        path: 'administrative-data',
      },
      {
        component: () => import('@shared/modules/Dvp/screens/Application/ScreenHealthquestions'),
        meta: {
          index: ROUTE_INDEX.APPLICATION_HEALTHQUESTIONS,
          basket: {
            readonly: true,
          },
          hideDefaultOverviewLink: true,
        },
        name: ROUTE_NAME.APPLICATION_HEALTHQUESTIONS,
        path: 'healthquestions/:personId?',
        props: route => ({
          personId: route.params.personId,
        }),
      },
    ],
  },
]
